"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductImage = getProductImage;
exports.getProductCategory = getProductCategory;
exports.getFormattedProductProperties = void 0;

require("core-js/modules/es.function.name.js");

// /**
//  * Given a product view, resolves the correct product look and sku based on the default IDs set on the view.
//  * @param {*} product the product view
//  */
// export function resolveProductLookAndSku(product: WProductView) {
//   const { productLooks, defaultProductLookId, defaultSkuId } = product;
//   const defaultProductLook =
//     _find(productLooks, (productLook) => productLook.id === defaultProductLookId) ||
//     productLooks[0];
//   const { skus } = defaultProductLook;
//   const defaultSku = _find(skus, (sku) => sku.id === defaultSkuId) || skus[0];
//   return {
//     productLook: defaultProductLook,
//     sku: defaultSku,
//   };
// }
// /**
//  * Determines whether a product's default SKU is addable to registry.
//  * @param {*} product the product view
//  */
// export function canAddToRegistry(product: WProductView) {
//   const { sku } = resolveProductLookAndSku(product);
//   return sku.canAddToRegistry;
// }
function getProductImage(productLook, imageSize) {
  var _productLook$images, _productLook$images$, _productLook$images$$;

  var isRectangularImage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var squareImage = productLook === null || productLook === void 0 ? void 0 : (_productLook$images = productLook.images) === null || _productLook$images === void 0 ? void 0 : (_productLook$images$ = _productLook$images[0].aspect_ratios) === null || _productLook$images$ === void 0 ? void 0 : (_productLook$images$$ = _productLook$images$['1x1']) === null || _productLook$images$$ === void 0 ? void 0 : _productLook$images$$[imageSize];
  var rectangularImage;

  if (isRectangularImage) {
    var _productLook$images2;

    var aspectRatios = productLook === null || productLook === void 0 ? void 0 : (_productLook$images2 = productLook.images) === null || _productLook$images2 === void 0 ? void 0 : _productLook$images2[0].aspect_ratios;
    var rectangularRatio = (aspectRatios === null || aspectRatios === void 0 ? void 0 : aspectRatios['3x4']) || (aspectRatios === null || aspectRatios === void 0 ? void 0 : aspectRatios['2x3']); // check for 3x4 ratio first, then fall back to deprecated 2x3 ratio

    rectangularImage = (rectangularRatio === null || rectangularRatio === void 0 ? void 0 : rectangularRatio[imageSize]) || squareImage; // use square image if we don't have a true rectangular one
  }

  var image = isRectangularImage ? rectangularImage : squareImage;
  return image;
}
/**
 * Gets the category for a product, if available.
 * Returns null if none is available.
 * @param {*} product the product
 */


function getProductCategory(product) {
  var categoryChain = product.category_chain;

  if (categoryChain && categoryChain.length) {
    return categoryChain[categoryChain.length - 1];
  }

  return null;
}

var getFormattedProductProperties = function getFormattedProductProperties(product) {
  var _product$product_look, _product$product_look2, _product$product_look3, _product$brand, _product$product_look4, _product$product_look5, _product$product_look6, _product$product_look7, _product$product_look8, _product$product_look9, _product$product_look10, _product$product_look11, _product$product_look12, _product$product_look13, _product$product_look14, _product$product_look15;

  var quantityMultiplier = product === null || product === void 0 ? void 0 : (_product$product_look = product.product_look_views) === null || _product$product_look === void 0 ? void 0 : (_product$product_look2 = _product$product_look[0]) === null || _product$product_look2 === void 0 ? void 0 : (_product$product_look3 = _product$product_look2.sku_previews) === null || _product$product_look3 === void 0 ? void 0 : _product$product_look3[0].quantity_multiplier;
  var name = product.display_name;
  var brand = (_product$brand = product.brand) === null || _product$brand === void 0 ? void 0 : _product$brand.name;
  var price_cents = product === null || product === void 0 ? void 0 : (_product$product_look4 = product.product_look_views) === null || _product$product_look4 === void 0 ? void 0 : (_product$product_look5 = _product$product_look4[0]) === null || _product$product_look5 === void 0 ? void 0 : (_product$product_look6 = _product$product_look5.sku_previews) === null || _product$product_look6 === void 0 ? void 0 : (_product$product_look7 = _product$product_look6[0]) === null || _product$product_look7 === void 0 ? void 0 : _product$product_look7.price_cents;
  var price = typeof price_cents === 'number' && typeof quantityMultiplier === 'number' ? price_cents * quantityMultiplier / 100 : undefined;
  var quantity = 1;
  var sku = (_product$product_look8 = product.product_look_views) === null || _product$product_look8 === void 0 ? void 0 : (_product$product_look9 = _product$product_look8[0].sku_previews) === null || _product$product_look9 === void 0 ? void 0 : _product$product_look9[0].id;
  var imageUrl = (_product$product_look10 = product.product_look_views) === null || _product$product_look10 === void 0 ? void 0 : (_product$product_look11 = _product$product_look10[0].images) === null || _product$product_look11 === void 0 ? void 0 : (_product$product_look12 = _product$product_look11[0].aspect_ratios) === null || _product$product_look12 === void 0 ? void 0 : _product$product_look12['1x1'].medium;
  var category = getProductCategory(product);
  return {
    product_id: product.id,
    sku: sku,
    sku_id: sku,
    category: category === null || category === void 0 ? void 0 : category.name,
    name: name,
    brand: brand,
    variant: (_product$product_look13 = product.product_look_views) === null || _product$product_look13 === void 0 ? void 0 : _product$product_look13[0].id,
    price: price,
    quantity: quantity,
    url: (_product$product_look14 = product.product_look_views) !== null && _product$product_look14 !== void 0 && _product$product_look14[0].key ? "/shop/product/".concat((_product$product_look15 = product.product_look_views) === null || _product$product_look15 === void 0 ? void 0 : _product$product_look15[0].key) : undefined,
    image_url: imageUrl
  };
};

exports.getFormattedProductProperties = getFormattedProductProperties;